import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonRadio,
  IonRadioGroup,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';

export interface LogFilterData {
  level?: string;
  area?: string;
  environment?: string;
  operation?: string;
  actorId?: string;
  correlationId?: string;
  startDate?: string;
  endDate?: string;
}

export const LOG_AREA_OPTIONS = [
  { value: 'server', label: 'Server Logs' },
  { value: 'ui', label: 'UI Logs' },
  { value: 'admin', label: 'Admin Logs' },
  { value: 'auth', label: 'Auth' },
  { value: 'payments', label: 'Payments' },
  { value: 'notifications', label: 'Notifications' },
  { value: 'dataHealth', label: 'Data Health' },
  { value: 'counters', label: 'Counters' },
  { value: 'qaRelease', label: 'QA / Release' },
];

@Component({
  selector: 'app-log-filter-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonButton,
    IonButtons,
    IonCol,
    IonContent,
    IonFooter,
    IonGrid,
    IonHeader,
    IonIcon,
    IonInput,
    IonItem,
    IonLabel,
    IonList,
    IonRadio,
    IonRadioGroup,
    IonRow,
    IonSelect,
    IonSelectOption,
    IonTitle,
    IonToolbar,
  ],
  templateUrl: './log-filter-modal.component.html',
  styleUrls: ['./log-filter-modal.component.scss'],
})
export class LogFilterModalComponent implements OnInit {
  private modalCtrl = inject(ModalController);

  @Input() filters?: LogFilterData | null;

  readonly areas = LOG_AREA_OPTIONS;
  selectedLevel = '';
  area = '';
  environment = '';
  operation = '';
  actorId = '';
  correlationId = '';
  startDate = '';
  endDate = '';

  ngOnInit() {
    this.selectedLevel = this.filters?.level || '';
    this.area = this.filters?.area || '';
    this.environment = this.filters?.environment || '';
    this.operation = this.filters?.operation || '';
    this.actorId = this.filters?.actorId || '';
    this.correlationId = this.filters?.correlationId || '';
    this.startDate = this.filters?.startDate || '';
    this.endDate = this.filters?.endDate || '';
  }

  clear() {
    this.modalCtrl.dismiss({ clear: true });
  }

  apply() {
    this.modalCtrl.dismiss({
      filters: {
        level: this.selectedLevel,
        area: this.area.trim(),
        environment: this.environment.trim(),
        operation: this.operation.trim(),
        actorId: this.actorId.trim(),
        correlationId: this.correlationId.trim(),
        startDate: this.startDate,
        endDate: this.endDate,
      } satisfies LogFilterData,
    });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
